import { render } from "./ManualRegistration.vue?vue&type=template&id=08de8e04&scoped=true&ts=true"
import script from "./ManualRegistration.vue?vue&type=script&lang=ts"
export * from "./ManualRegistration.vue?vue&type=script&lang=ts"

import "./ManualRegistration.vue?vue&type=style&index=0&id=08de8e04&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08de8e04"]])

export default __exports__